/**
 * Roles definidos en el backend (`UserRole` en `apps/local-api/src/.../people.py`).
 */
export const Role = {
  TENANT_OWNER: "tenant_owner",
  TENANT_ADMIN: "tenant_admin",
  BRANCH_ADMIN: "branch_admin",
  CASHIER: "cashier",
} as const;
export type Role = (typeof Role)[keyof typeof Role];

/** Roles con acceso a la consola admin (catálogo, sucursales, usuarios, etc.). */
export const ADMIN_ROLES: ReadonlyArray<Role> = [
  Role.TENANT_OWNER,
  Role.TENANT_ADMIN,
  Role.BRANCH_ADMIN,
];

export function isAdminRole(role: string | null | undefined): boolean {
  return role != null && (ADMIN_ROLES as readonly string[]).includes(role);
}

/** Path al que redirigimos después de un login exitoso, según rol. */
export function postLoginPath(role: string | null | undefined): string {
  // /admin decide: primeros pasos mientras falte configurar, si no reportes.
  return isAdminRole(role) ? "/admin" : "/";
}
